<template>
  <label
    class="switcher"
    :class="{
      'switcher--active': value,
      'switcher--readonly': readonly,
      'switcher--design-new': design === 'new'
    }"
  >
    <input
      :checked="value"
      :disabled="disabled"
      :aria-label="ariaLabel || null"
      @change="$emit('change', $event.target.checked)"
      class="switcher__input"
      type="checkbox"
    >
    <span class="switcher__view">
      <span class="switcher__body"></span>
      <span class="switcher__btn"></span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'AppSwitcher',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    }
  },
}
</script>

<style lang="sass" scoped>
.switcher
  position: relative
  display: inline-block

.switcher--active
  .switcher__body
    background-color: $color-theme

  .switcher__btn
    left: 18px

  .switcher__value
    color: #38bf4e

  &.switcher--additional
    .switcher__btn
      left: 15px

.switcher--readonly
  pointer-events: none

  &.switcher--active
    .switcher__body
      background-color: #ff9416

  .switcher__btn
    border: 1px solid #ff9416

.switcher--additional
  .switcher__view
    width: 30px
    height: 15px

  .switcher__btn
    width: 13px
    height: 13px

.switcher__input
  +visually-hidden

.switcher__view
  position: relative
  display: block
  width: 40px
  height: 24px
  cursor: pointer

.switcher__body
  display: block
  width: 100%
  height: 100%
  border-radius: 20px
  background-color: #efefef
  overflow: hidden
  transition: background-color 0.3s, border-color 0.3s

.switcher__btn
  position: absolute
  top: 50%
  left: 3px
  width: 19px
  height: 19px
  background-color: #fff
  border-radius: 50%
  transform: translateY(-50%)
  transition: background-color 0.3s, left 0.3s

.switcher__value
  color: $color-error

.switcher--design-new
  .switcher__input:focus-visible + .switcher__view
    outline: 3px solid var(--ui-accent-soft, #{rgba($ui-blue, .18)})
    outline-offset: 2px
    border-radius: 20px

  .switcher__body
    background-color: $ui-line-strong

  .switcher__btn
    box-shadow: none

  &.switcher--active
    .switcher__body
      background-color: var(--ui-accent, #{$ui-blue})

  &.switcher--readonly
    opacity: .72

    .switcher__btn
      border-color: $ui-line-strong

    &.switcher--active .switcher__body
      background-color: $ui-muted
</style>
